export const CatAxisBottom = ( {x, innerHeight } ) => (
  x.domain().map(tickValue => (
    null
  ))
);
